import React, { Component } from 'react'
import { Modal } from 'antd'
import { both, clone, is, complement, equals, map, addIndex } from 'ramda'
import PropTypes from 'prop-types'
import shortid from 'shortid'
import AreaCrop, { coordinateType } from './AreaCrop'

const isValidPoint = (point = {}) => {
  const strictNumber = number => both(
    is(Number),
    complement(equals(NaN)),
  )(number)
  return strictNumber(point.x) && strictNumber(point.y)
}


class HotArea extends Component {

  state = {
    visible: false,
    selectedId: this.props.selectedId || - 1
  }

  drawingIndex = -1

  pointA = {}

  id = shortid.generate()

  renderAreaCrops = (props) => {
    let self = this;
    let arr = [];
    props.coordinates.forEach((coor, index) => {
      let className = this.getClassName("AreaCrop_Outer");
      let bSelected = self.state.selectedId == coor.id ? true : false;
      if (bSelected) {
        className = className + " " + this.getClassName("AreaCrop_Selected");
      }
      arr.push(
        <div onClick={() => this.handelSelectArea(coor)} className={className}>
          <AreaCrop
            // improve performance when delet crop in middle array
            key={coor.id || index}
            index={index}
            coordinate={coor}
            extendClassName={this.props.extendClassName}
            bSelected={bSelected}
            isReadOnly={this.isReadOnly()}
            doFunc={this.props.doFunc}
            {...props}
          />
        </div>);
    });
    return arr;
  }

  getCursorPosition = (e) => {
    const { left, top } = this.container.getBoundingClientRect()
    return {
      x: e.clientX - left,
      y: e.clientY - top,
    }
  }
  isReadOnly = () => {
    return !!this.props.isReadOnly;
  }
  handleMouseDown = (e) => {
    const { coordinates } = this.props
    if (!this.isReadOnly()) {
      if (e.target === this.img || e.target === this.container) {
        const { x, y } = this.getCursorPosition(e)

        this.drawingIndex = coordinates.length
        this.pointA = { x, y }
        this.id = shortid.generate()

      }
    }
  }

  setNewCropSelected(id) {
    if (this.state.selectedId != id) {
      this.state.selectedId = id
      if (this.props.selectArea)
        this.props.selectArea({ id });
    }
  }
  handleMouseMove = (e) => {
    const { onDraw, onChange, coordinates } = this.props
    const { pointA } = this
    if (!this.isReadOnly()) {
      if (isValidPoint(pointA)) {
        const pointB = this.getCursorPosition(e)

        // get the drawing coordinate
        const coordinate = {
          x: Math.min(pointA.x, pointB.x),
          y: Math.min(pointA.y, pointB.y),
          width: Math.abs(pointA.x - pointB.x),
          height: Math.abs(pointA.y - pointB.y),
          id: this.id,
        }
        const nextCoordinates = clone(coordinates)
        nextCoordinates[this.drawingIndex] = coordinate
        this.setNewCropSelected(coordinate.id);
        if (is(Function, onDraw)) {
          onDraw(coordinate, this.drawingIndex, nextCoordinates)
        }
        if (is(Function, onChange)) {
          onChange(coordinate, this.drawingIndex, nextCoordinates)
        }
      }
    }
  }

  handlMouseUp = () => {
    this.pointA = {}
  }

  handelSelectArea = (coordinate) => {
    if (this.state.selectedId != coordinate.id && this.props.selectArea) {
      this.state.selectedId = coordinate.id;
      this.props.selectArea(coordinate);
    }
    event.preventDefault();
  }

  getClassName(str) {
    let className = "HotArea_" + str;
    if (!!this.props.extendClassName) {
      className = className + " " + this.props.extendClassName + "HotArea_" + str
    }
    return className;
  }

  render() {
    const {
      src, width, height, onLoad, onError
    } = this.props
    // const { clicked } = this.state
    return (
      <div className={this.getClassName("Media")}>
        <div
          className={this.getClassName("Inner")}
          style={{
            display: 'inline-block',
            position: 'relative',
          }}
          onMouseDown={this.handleMouseDown}
          onMouseMove={this.handleMouseMove}
          onMouseUp={this.handlMouseUp}
          ref={container => this.container = container}
        >
          <img
            ref={img => this.img = img}
            src={src}
            width={width}
            height={height}
            onLoad={onLoad}
            onError={onError}
            alt=""
            draggable={false}
            className={this.getClassName("Img")}
          />
          {this.renderAreaCrops(this.props)}
          {/* <Modal
          title="Basic Modal"
          visible={this.state.visible}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
          className="hotarea-modal"
        >
          <InputCrop></InputCrop>
        </Modal> */}
        </div>
      </div>
    )
  }
}

const {
  string, arrayOf, number, func,
} = PropTypes

HotArea.propTypes = {
  coordinates: arrayOf(coordinateType),
  src: string,
  width: number, // eslint-disable-line
  height: number, // eslint-disable-line
  onDraw: func, // eslint-disable-line
  onChange: func, // eslint-disable-line
  onLoad: func, // eslint-disable-line
}

HotArea.defaultProps = {
  coordinates: [],
  src: '',
}

export default HotArea




// WEBPACK FOOTER //
// ./src/yxyweb/common/components/meta/HotArea/components/HotArea.js